.container {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    z-index: 1;
    position: relative;
}

/* Should match the content-container in ai-page-wrapper.module.css */
.content-container {
    max-width: 1200px;
    overflow: hidden;
    width: 100%;
    padding: 48px 64px;
}

.content-container--has-nav-header {
    flex-direction: column;
    padding: 0 64px 48px 64px;
}

.illustration {
    flex: 0 0 33%;
    height: 300px;
    min-width: 300px;
}

.illustration img,
.illustration svg {
    width: 100%;
    max-width: 100%;
    max-height: 300px;
}

.nav-header {
    width: 100%;
    /* match height of header without a nav header (the 48px top padding) */
    min-height: 48px;
}
